import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};
const getBrowserLanguage = () => {
  const preferredLanguage = localStorage && localStorage.getItem && localStorage.getItem("language")
  if (preferredLanguage) {
    return preferredLanguage;
  }
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0]; // Most preferred language
  }
  return "en"
};

const userLang = getBrowserLanguage();
console.log("The browser language is:", userLang);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: userLang,
    nonExplicitSupportedLngs: true,
    supportedLngs: ["en", "es"],
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    fallbackLng: "en"
  });

export default i18n;
